import moment from "moment-timezone";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const businessHours = (businessHoursData) => {
  const now = moment().tz("America/Mexico_City"); // Obtén la fecha y hora actual en la zona horaria de México
  const dayOfWeek = now.day(); // Sunday = 0, Monday = 1, etc.
  const hours = now.hours();

  const currentDay = businessHoursData[dayOfWeek];
  if (!currentDay || !currentDay.isActive) return false;

  let isInsideBusinessHours =
    hours >= currentDay.start && hours < currentDay.end;

  return isInsideBusinessHours;
};

const checkIfIsInsideBussinessHours = async (department) => {
  const REPLY_ID_TO_DEPARTMENT = {
    "Technical support": {
      name: "Soporte Técnico",
      id: "technical_support",
      message:
        "Un agente viene en camino. Debido a una alta demanda el tiempo promedio de espera es de 14 minutos. Mientras tanto, por favor escribe tu consulta para que podamos atenderte más rápido 😊",
    },
    "Customer support": {
      name: "Atención A Clientes",
      id: "customer_support",
      message:
        "Un agente viene en camino. Debido a una alta demanda el tiempo promedio de espera es de 14 minutos. Mientras tanto, por favor escribe tu consulta para que podamos atenderte más rápido 😊",
    },
    Sales: {
      name: "Ventas",
      id: "sales",
      message:
        "Un agente viene en camino. Debido a una alta demanda el tiempo promedio de espera es de 14 minutos. Mientras tanto, por favor escribe tu consulta para que podamos atenderte más rápido 😊",
    },
    Claims: {
      name: "Siniestros y Asistencias",
      id: "assistance",
      message:
        "Te puedes comunicar con el departamento de siniestros y asistencias aquí 😊",
    },
    General: {
      name: "Ventas",
      id: "sales",
      message:
        "Un agente viene en camino. Debido a una alta demanda el tiempo promedio de espera es de 14 minutos. Mientras tanto, por favor escribe tu consulta para que podamos atenderte más rápido 😊",
    },
  };

  let departmentInfo = REPLY_ID_TO_DEPARTMENT[department];
  try {
    const businessHoursDoc = doc(
      db,
      `IT/businessHours/departments/${departmentInfo.id}`
    );
    const businessHoursSnapshot = await getDoc(businessHoursDoc);

    const businessHoursData = businessHoursSnapshot.data()?.businessHoursData;
    const isInsideBusinessHours = businessHours(businessHoursData);
    return {
      isInsideBusinessHours,
      departmentInfoHours: { ...departmentInfo, ...businessHoursData },
      businessHoursData,
    };
  } catch (err) {
    return {};
  }
};

export default checkIfIsInsideBussinessHours;
